import { useActiveOrg } from "@/features/organizations/hooks/use-active-org";

/**
 * Active `organization_id` for the inventory scope — the ONLY point through
 * which the WMS scope passes.
 *
 * Multi-organization: returns the id of the ACTIVE company/supermarket (chosen
 * in the switcher), or the userId when the active scope is Personal (personal
 * inventory F1 / visitor mode with `VISITOR_ID`). Since all WMS routes
 * (catalog, warehouses, stock, operations, purchases, counts, lots,
 * manufacturing, valuation, replenishment, dashboard, trash) derive from
 * this accessor, changing organization re-scopes EVERYTHING reactively without
 * reloading or prop-drilling.
 *
 * The scope is validated against locally synchronized orgs (self-healing:
 * it falls back to Personal if the pointer became stale), so it never points
 * to a nonexistent org that would leave inventory empty forever.
 */
export function useOrgId(): () => string {
  const { activeScopeId } = useActiveOrg();
  return activeScopeId;
}
